/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconUnplugged: {
  name: 'unplugged';
  data: string;
} = {
  name: 'unplugged',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M338.552 266.038c-4.875 0-8.898 3.652-9.488 8.367h-4.856v2.391h4.856c.59 4.715 4.613 8.367 9.488 8.367h1.195c.662 0 1.195-.533 1.195-1.195v-2.391h3.586v-2.391h-3.586v-7.172h3.586v-2.391h-3.586v-2.391c0-.662-.533-1.195-1.195-1.195l-1.195.001zm16.734 0c-.662 0-1.195.533-1.195 1.195v2.391h2.391v2.391h-2.391v7.172h2.391v2.391h-2.391v2.391c0 .662.533 1.195 1.195 1.195h7.172v-19.125l-7.172-.001z" transform="matrix(15 0 0 15 -4844 -3824)"/></svg>`,
};
